import React, { useEffect, useState } from 'react';
import { Table, Typography } from 'antd';
import { editExport, showExport } from '@app/api/export.api';

const { Title } = Typography;

interface PackingListViewProps {
  export_id: string | null;
}

const PackingListView: React.FC<PackingListViewProps> = ({ export_id }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [productOptions, setProductOptions] = useState<{ value: number; label: string }[]>([]);

  useEffect(() => {
    if (!export_id) return;

    const fetchExportData = async () => {
      try {
        // Fetch data for export and product options
        const response = await showExport(Number(export_id));
        setProductOptions(response.pr_options || []);

        const formattedData =
          response?.export?.export_lines?.flatMap((exportLine: any, lineIndex: number) => {
            return exportLine.export_line_varieties.map((variety: any, varietyIndex: number) => ({
              key: `${lineIndex}-${varietyIndex}-${exportLine.product_id}-${variety.product_variety_id}`,
              labVerification: variety.lab_verification,
              productSpecies: variety.L4?.species || 'Unknown',
              productVarieties: variety.product_variety?.name || 'Unknown',
              brandName: variety.L4?.brand_names,
              quantity: variety.quantity,
            }));
          }) ?? [];
        setTableData(formattedData);
      } catch (error) {
        console.error('Failed to fetch product options:', error);
      }
    };

    fetchExportData();
  }, [export_id]);

  const columns = [
    { title: 'Product Species', dataIndex: 'productSpecies' },
    { title: 'Product Variety', dataIndex: 'productVarieties' },
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      render: (text: any) => (Array.isArray(text) ? text.join(', ') : text), // Check if it's an array before joining
    },
    { title: 'Quantity (Tons)', dataIndex: 'quantity' },
    { title: 'Lab Verification', dataIndex: 'labVerification' },
  ];

  return (
    <div>
      <Title level={4}>Packing List</Title>
      <Table columns={columns} dataSource={tableData} rowKey="key" pagination={false} style={{ marginTop: 20 }} />
    </div>
  );
};

export default PackingListView;
